import { render, staticRenderFns } from "./VideoButtons.vue?vue&type=template&id=f0ac4abe&scoped=true&"
import script from "./VideoButtons.vue?vue&type=script&lang=js&"
export * from "./VideoButtons.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/video_buttons.css?vue&type=style&index=0&id=f0ac4abe&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/sp/video_buttons.css?vue&type=style&index=1&id=f0ac4abe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ac4abe",
  null
  
)

export default component.exports